import { motion } from "framer-motion";

const TickLoader = () => {
  return (
    <motion.svg
      width="53"
      height="34"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-18 h-18"
    >
      {/* Outer Circle (White) - spinning */}
      <motion.path
        d="M32.0693 15.8564C32.0693 24.46 25.0948 31.4346 16.4912 31.4346C7.88765 31.4346 0.913086 24.46 0.913086 15.8564C0.913086 7.25288 7.88765 0.27832 16.4912 0.27832C25.0948 0.27832 32.0693 7.25288 32.0693 15.8564Z"
        fill="white"
      />

      {/* Inner Red Tick Path - draw animation */}
      <motion.path
        d="M16.4912 29.2037C14.6503 29.2037 12.9136 28.4095 11.7271 27.0247C9.98355 27.2205 8.18681 26.5742 6.88482 25.2951C5.58397 24.016 4.92731 22.2474 5.08468 20.4433C3.71364 19.371 2.90527 17.6647 2.90527 15.8561C2.90527 14.0475 3.71364 12.3413 5.12431 11.1756C4.92618 9.46598 5.58284 7.69742 6.88482 6.41828C8.18681 5.13914 9.98355 4.49067 11.8222 4.64972C12.9136 3.30384 14.6503 2.50855 16.4912 2.50855C18.3321 2.50855 20.0688 3.30273 21.2553 4.68754C23.0011 4.49511 24.7956 5.13802 26.0976 6.41717C27.3985 7.69631 28.0551 9.46487 27.8977 11.269C29.2688 12.3413 30.0771 14.0475 30.0771 15.8561C30.0771 17.6647 29.2688 19.371 27.8581 20.5367C28.0562 22.2463 27.3996 24.0148 26.0976 25.294C24.7945 26.5731 22.9943 27.2138 21.1602 27.0625C20.0688 28.4084 18.3321 29.2037 16.4912 29.2037Z
        M17.3981 19.3432L22.7634 14.2622C23.2129 13.8362 23.2264 13.131 22.7917 12.6894C22.3581 12.2478 21.6414 12.2345 21.1908 12.6605L15.8108 17.7559C15.3681 18.1908 14.6537 18.1909 14.1805 17.7281L11.6014 15.3734C11.1463 14.9563 10.4285 14.9808 10.0017 15.4312C9.57597 15.8806 9.60201 16.5847 10.0605 17.0029L12.6102 19.3298C13.2736 19.9817 14.1465 20.3076 15.0171 20.3076C15.8832 20.3076 16.7448 19.9861 17.3992 19.3443L17.3981 19.3432Z"
        fill="none"
        stroke="#DC3912"
        strokeWidth={1.5}
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
        }}
      />
    </motion.svg>
  );
};

export default TickLoader;
